import { jsxs as p, jsx as a } from "react/jsx-runtime";
import { R as x, I as w } from "../../../index-CmcwG6Gg.js";
import { c as m } from "../../../clsx-OuTLNxxd.js";
import { useRef as N, useEffect as v } from "react";
import { B as y } from "../../../button.types-BqgkEc5r.js";
import "../button/iconButton/iconButton.js";
import { Title as E } from "../title/title.js";
const e = {
  "panel-container": "_panel-container_11fx7_29",
  "with-progress-bar": "_with-progress-bar_11fx7_41",
  "title-container": "_title-container_11fx7_44",
  "with-picture-mobile": "_with-picture-mobile_11fx7_47",
  "is-warning": "_is-warning_11fx7_50",
  "with-picture": "_with-picture_11fx7_47",
  "panel-title": "_panel-title_11fx7_73",
  "panel-description": "_panel-description_11fx7_77",
  "width-image": "_width-image_11fx7_90",
  "panel-button": "_panel-button_11fx7_97",
  "panel-progress-bar-container": "_panel-progress-bar-container_11fx7_108",
  "panel-progress-bar": "_panel-progress-bar_11fx7_108",
  "panel-progress-bar-indicator": "_panel-progress-bar-indicator_11fx7_126",
  "panel-bg-illustration": "_panel-bg-illustration_11fx7_141",
  "panel-illustration": "_panel-illustration_11fx7_142",
  "dialog-overlay-show": "_dialog-overlay-show_11fx7_1",
  "dialog-content-show": "_dialog-content-show_11fx7_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_11fx7_1"
}, S = {
  warning: "is-warning"
};
function j({
  title: o,
  onClick: f,
  actionText: d,
  percentage: n,
  pictureUrl: i,
  bgPictureUrl: r,
  displayPictureOnMobile: g = !0,
  className: h,
  status: c,
  children: u
}) {
  const s = N(null);
  return v(() => {
    const t = (b) => {
      if (b.target.tagName !== "BUTTON") {
        const _ = s.current?.querySelector("button");
        _ && _.click();
      }
    }, l = s.current;
    return l && l.addEventListener("click", t), () => {
      l && l.removeEventListener("click", t);
    };
  }, []), /* @__PURE__ */ p(
    "div",
    {
      ref: s,
      className: m(
        e["panel-container"],
        n && e["with-progress-bar"],
        (r || i) && (g ? e["with-picture-mobile"] : e["with-picture"]),
        c && e[S[c]],
        h
      ),
      children: [
        /* @__PURE__ */ a("div", { className: e["title-container"], children: /* @__PURE__ */ a(E, { className: e["panel-title"], level: 3, children: o }) }),
        /* @__PURE__ */ a("div", { className: m(e["panel-description"], (r || i) && e["width-image"]), children: u }),
        /* @__PURE__ */ a(
          y,
          {
            onClick: (t) => {
              f?.(), t.stopPropagation();
            },
            color: "primary",
            className: e["panel-button"],
            size: "medium",
            children: d
          }
        ),
        n !== void 0 && /* @__PURE__ */ p("div", { className: e["panel-progress-bar-container"], children: [
          /* @__PURE__ */ a(x, { className: e["panel-progress-bar"], "aria-label": "progress-bar-panel", children: /* @__PURE__ */ a(
            w,
            {
              className: e["panel-progress-bar-indicator"],
              style: { transform: `translateX(-${100 - n}%)` }
            }
          ) }),
          /* @__PURE__ */ p("span", { children: [
            n,
            "%"
          ] })
        ] }),
        r && /* @__PURE__ */ a("img", { className: e["panel-bg-illustration"], alt: o, src: r }),
        i && /* @__PURE__ */ a("img", { className: e["panel-illustration"], alt: o, src: i })
      ]
    }
  );
}
export {
  j as Panel
};
